import {inject, Injectable} from '@angular/core';
import {RecordData, RecordTableColumnParams} from "../../../types/records-table.types";
import {RecordsTableService} from "../../../services/records-table.service";

@Injectable({
  providedIn: 'root'
})
export class RecordsTableAddRecordFormService {
  private recordsTableService: RecordsTableService = inject(RecordsTableService);

  public createEmptyRecordData(tableColumnsParams: Array<RecordTableColumnParams>): Partial<RecordData> {
    const recordDataForCreation: Partial<RecordData> = { }

    for (let param of tableColumnsParams) {
      if (param.omit) { continue; }
      if (!param.editable) { continue; }

      recordDataForCreation[param.key] = this.recordsTableService.getDefaultValueAccordingToType(param.type);
    }

    return recordDataForCreation;
  }
}
